// extracted by mini-css-extract-plugin
export default {"technologyList":"TechnologyList-module--technologyList--24VjP","technologyListItem":"TechnologyList-module--technologyListItem--1I-FI"};